import React from "react";
import ReactDOM from "react-dom";
import "./assets/scss/styles.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initTracking } from "./utils/tracking";

const ENV = window.ENV[window.location.hostname] || window.ENV.default;
initTracking(ENV.GTM_ID);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
